import SearchResults from '@features/search/SearchForm/SearchResults';
import { useDebounce } from '@store/hooks/useDebounce';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface SearchFormProps {
  apiUrl: string;
  formUrl: string;
}

export default function SearchForm({ apiUrl, formUrl }: SearchFormProps) {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState<string | undefined>();
  const debounceSearchTerm = useDebounce(searchTerm, 300);

  const searchLink = useMemo(() => {
    const url = new URL(formUrl, window.location.origin);
    url.searchParams.set('searchTerm', debounceSearchTerm);
    return url.toString();
  }, [debounceSearchTerm, formUrl]);

  return (
    <form action={formUrl} className="form relative w-full" method="get">
      <div className="flex w-full">
        <div className="input w-full">
          <input
            aria-disabled="true"
            autoComplete="off"
            className="w-full h-10 p-2 appearance-none focus:ring-0 focus:ring-offset-0 !text-primary border border-r-0 !rounded-none tracking-widest"
            name="searchTerm"
            placeholder={t('WhatAreYouLookingFor')}
            required
            type="search"
            onChange={event => setSearchTerm(event.currentTarget.value)}
          />
        </div>
        <button
          aria-disabled="true"
          aria-label={t('ToSearch')}
          className="flex justify-center items-center border border-l-0 border-primary bg-primary text-white p-3 w-12 h-10 outline-none hover:text-accent-dark">
          <i className="fa-solid fa-magnifying-glass"></i>
        </button>
      </div>

      {debounceSearchTerm && debounceSearchTerm.length >= 3 && (
        <SearchResults apiUrl={apiUrl} searchTerm={debounceSearchTerm} searchLink={searchLink} />
      )}
    </form>
  );
}
